import { Renderer } from '@unseenco/taxi';
import { globalStorage, isDEVMODE, viewStorage } from '../_globals'
import EcosystemList from '../modules/ecosystem-list'
import SteeringCommitteeSwiper from '../modules/steering-committee-swiper'
import Committees from '../modules/committees'
import Accordeons from '../modules/accordeons'
import StepsMenu from '../modules/steps-menu'
import Form from '../modules/form'

export default class DefaultPageRenderer extends Renderer {

  initialLoad() {

    const onDOMContentLoaded = () => {
      document.removeEventListener('DOMContentLoaded', onDOMContentLoaded)
      this.onEnter()
    }

    document.addEventListener('DOMContentLoaded', onDOMContentLoaded)

  }

  onEnter() {
    this.DOM = {
      ContentLibrary: document.querySelector('.OurEcosystem'),
      swiperSteeringCommittee: viewStorage.current.querySelector('.SteeringCommittee .swiper'),
      sectionCommittee: viewStorage.current.querySelector('.section--committee'),
      sectionSteps: viewStorage.current.querySelector('.section--steps'),
    }

    this.init()
  }

  init() {
    
    if (this.DOM.swiperSteeringCommittee) {
      this.steeringCommittee = new SteeringCommitteeSwiper(this.DOM.swiperSteeringCommittee)
    }

    // Committee
    if (this.DOM.sectionCommittee) {
      this.committeesModule = new Committees(this.DOM.sectionCommittee)
    }

    // Accordions
    this.accordeonsModule = new Accordeons(viewStorage.current)

    // Steps menu
    if (this.DOM.sectionSteps) this.stepsMenuModule = new StepsMenu(this.DOM.sectionSteps)

    // Form
    this.stepsMenu = viewStorage.current.querySelectorAll('.steps--item .steps--item__nav');
    this.inputsConditional = viewStorage.current.querySelectorAll('input[type="radio"][name="hearAbout-segment_field"]');
    this.inputsConditional2 = viewStorage.current.querySelectorAll('input[type="radio"][name="dedicated-sustainability-team_field"]');
    this.inputsConditional3 = viewStorage.current.querySelectorAll('input[type="radio"][name="specific-topics_field"]');
    this.inputsConditional4 = viewStorage.current.querySelectorAll('input[type="radio"][name="other-org_field"]');
    this.linkedInputForHearAboutSegmentField5 = viewStorage.current.querySelector('.linkedInput-for-hearAbout-segment_field_5')

    this.inputsConditional.forEach(input => {
      input.addEventListener('change', (e) => {
          const id = e.currentTarget.getAttribute('id')

          this.linkedInputForHearAboutSegmentField5.querySelector('textarea').value = ''
          
          if (id === 'hearAbout-segment_field_1' || id == 'hearAbout-segment_field_5') {
            if (e.currentTarget.checked) {
              this.linkedInputForHearAboutSegmentField5.classList.add('--active')
              this.linkedInputForHearAboutSegmentField5.querySelector('textarea').focus()
            }
          } else {
            this.linkedInputForHearAboutSegmentField5.classList.remove('--active')
            this.linkedInputForHearAboutSegmentField5.querySelector('textarea').blur()
          }
        })
      }
    )

    this.inputsConditional2.forEach(
      input => {
        input.addEventListener('click', (e) => {
          const id = e.currentTarget.getAttribute('id')
          const idLinkedInput = ''
          if (id == 'dedicated-sustainability-team_field_1') {
            if ((e.currentTarget.checked == true)) {
              const idLinkedInput = '.linkedCheckbox-for-' + id
              viewStorage.current.querySelectorAll(idLinkedInput).forEach(
                conditionalInput => conditionalInput.classList.add('--active')
              )
            }
          }
          else {
            e.currentTarget.parentNode.parentNode.parentNode.querySelectorAll('.conditional').forEach(
              conditionalInput => conditionalInput.classList.remove('--active')
            )
          }
        })
      }
    )

    this.inputsConditional3.forEach(
      input => {
        input.addEventListener('click', (e) => {
          const id = e.currentTarget.getAttribute('id')
          const idLinkedInput = ''
          if (id == 'specific-topics_field_1') {
            if ((e.currentTarget.checked == true)) {
              const idLinkedInput = '.linkedInput-for-' + id
              viewStorage.current.querySelectorAll(idLinkedInput).forEach(
                conditionalInput => conditionalInput.classList.add('--active')
              )
            }
          }
          else {
            e.currentTarget.parentNode.parentNode.parentNode.querySelectorAll('.conditional').forEach(
              conditionalInput => conditionalInput.classList.remove('--active')
            )
          }
        })
      }
    )

    this.inputsConditional4.forEach(
      input => {
        input.addEventListener('click', (e) => {
          const id = e.currentTarget.getAttribute('id')
          const idLinkedInput = ''
          if (id == 'other-org_field_1') {
            if ((e.currentTarget.checked == true)) {
              const idLinkedInput = '.linkedInput-for-' + id
              viewStorage.current.querySelectorAll(idLinkedInput).forEach(
                conditionalInput => conditionalInput.classList.add('--active')
              )
            }
          }
          else {
            e.currentTarget.parentNode.parentNode.parentNode.querySelectorAll('.conditional').forEach(
              conditionalInput => conditionalInput.classList.remove('--active')
            )
          }
        })
      }
    )

    this.myForm = new Form(viewStorage.current.querySelector('.ContactForm'))
  }

  onLeaveCompleted() {
    this.steeringCommittee && this.steeringCommittee.destroy()
    this.accordeonsModule && this.accordeonsModule.destroy()
    this.stepsMenuModule && this.stepsMenuModule.destroy()

    if (this.myForm) this.myForm.destroy();
    this.stepsMenu.forEach(
      navItem => {
        navItem.removeEventListener('click', this.inputsConditional)
        // console.log("remove")
      }
    )
    this.inputsConditional.forEach(
      input => {
        input.removeEventListener('click', this.inputsConditional)
        // console.log("remove")
      }
    )
    this.inputsConditional2.forEach(
      input => {
        input.removeEventListener('click', this.inputsConditional2)
      }
    )
    this.inputsConditional3.forEach(
      input => {
        input.removeEventListener('click', this.inputsConditional3)
      }
    )
    this.inputsConditional4.forEach(
      input => {
        input.removeEventListener('click', this.inputsConditional4)
      }
    )
  }
}
